import { Instance } from "mobx-state-tree";
import { useRootStore } from "../../root/store/RootStore";
import { AllowedDomainsStore } from "./AllowedDomainsStore";
import { AllowedDomainDetailsStore } from "./AllowedDomainDetailsStore";
import { CreateAllowedDomainStore } from "./CreateAllowedDomainStore";
import { UpdateAllowedDomainStore } from "./UpdateAllowedDomainStore";
import { DeleteAllowedDomainStore } from "./DeleteAllowedDomainStore";

export const useAllowedDomainsStore = (): Instance<
  typeof AllowedDomainsStore
> => useRootStore().allowedDomainsStore;

export const useAllowedDomainDetailsStore = (): Instance<
  typeof AllowedDomainDetailsStore
> => useRootStore().allowedDomainDetailsStore;

export const useCreateAllowedDomainStore = (): Instance<
  typeof CreateAllowedDomainStore
> => useAllowedDomainDetailsStore().createAllowedDomainStore;

export const useUpdateAllowedDomainStore = (): Instance<
  typeof UpdateAllowedDomainStore
> => useAllowedDomainDetailsStore().updateAllowedDomainStore;

export const useDeleteAllowedDomainStore = (): Instance<
  typeof DeleteAllowedDomainStore
> => useAllowedDomainDetailsStore().deleteAllowedDomainStore;
